module.exports = __webpack_public_path__ + "static/media/1013511.3d2b6271.png";